import { createContext, type ErrorInfo, useContext } from "react";

export type ErrorBoundaryRetryState = {
  attemptLimit: number;
  attempts: number;
  attemptDelay: number;
  onNewAttempt: () => void;
  onResetAttempts: () => void;
  onError: (error: Error, info: ErrorInfo) => void;
  onReset: () => void;
};

export const defaultErrorBoundaryRetryState: ErrorBoundaryRetryState = {
  attemptLimit: 10,
  attempts: 0,
  attemptDelay: 0,
  onNewAttempt: () => undefined,
  onResetAttempts: () => undefined,
  onError: (error) => {
    console.error(error?.message, error);
  },
  onReset: () => undefined,
};

export const ErrorBoundaryRetryStateContext =
  createContext<ErrorBoundaryRetryState>(defaultErrorBoundaryRetryState);

export const useErrorBoundaryRetryState = () =>
  useContext(ErrorBoundaryRetryStateContext);
